import React, { useEffect, createElement } from 'react';
import { ArrowRightIcon, HomeIcon, SearchIcon, MapPinIcon, BookOpenIcon } from 'lucide-react';
export function NotFoundPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Pagina niet gevonden | Noord';
    let metaDesc = document.querySelector('meta[name="description"]') as HTMLMetaElement;
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = "Deze pagina bestaat niet. Ga terug naar de homepage van Noord Digital of bekijk onze diensten, sectoren en lokale webdesign pagina's.";
    // Open Graph meta tags
    const ogTags: Record<string, string> = {
      'og:title': 'Pagina niet gevonden | Noord',
      'og:description': 'Deze pagina bestaat niet. Ga terug naar de homepage van Noord Digital.',
      'og:type': 'website',
      'og:site_name': 'Noord Digital',
      'og:locale': 'nl_NL'
    };
    Object.entries(ogTags).forEach(([property, content]) => {
      let tag = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement;
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.content = content;
    });
  }, []);
  return <main className="pt-16 lg:pt-[72px] min-h-[80vh] flex flex-col" data-id="element-1594" data-mp="1f302nzjyjyxr">
      <section className="relative flex-grow flex items-center justify-center py-20 lg:py-32 bg-navy-900 overflow-hidden" data-id="element-1595" data-mp="1f4td7pxoz3b1">
        {/* Background decorative elements */}
        <div className="absolute inset-0 pointer-events-none" data-id="element-1596" data-mp="1o3y7ul64uchx">
          <div className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full opacity-20 blur-3xl bg-accent" data-id="element-1597" data-mp="1t2hxavjxq6f1" />
          <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full opacity-10 blur-3xl bg-accent-light" data-id="element-1598" data-mp="3pvtegmdj7qta" />
          <div className="absolute inset-0 opacity-[0.03]" style={{
          backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
          backgroundSize: '32px 32px'
        }} data-id="element-1599" data-mp="3utuvz2vb7i2n" />
        </div>

        <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full" data-id="element-1600" data-mp="1b1dr5394kre6">
          <div className="text-8xl md:text-9xl font-extrabold text-accent/20 mb-4 animate-fade-in-up select-none" data-id="element-1601" data-mp="15z6ai0dcon5i">
            404
          </div>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white mb-6 animate-fade-in-up-delay-1" data-id="element-1602" data-mp="1fz5j1x9rsdid">
            Pagina niet gevonden
          </h1>
          <p className="text-lg text-navy-200 mb-12 animate-fade-in-up-delay-2" data-id="element-1603" data-mp="1tpionsz6vg4j">
            De pagina die je zoekt bestaat niet of is verplaatst.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-left animate-fade-in-up-delay-3 max-w-2xl mx-auto" data-id="element-1604" data-mp="23pjdtvjqoqgn">
            <a href="#/" className="flex items-center justify-between bg-white/5 hover:bg-white/10 border border-white/10 p-5 rounded-xl transition-all group" data-id="element-1605" data-mp="1yqyc1rou9yq3">
              <div className="flex items-center gap-3" data-id="element-1606" data-mp="2n9rqsv2v7cdx">
                <HomeIcon className="w-5 h-5 text-accent" data-id="element-1607" data-mp="28dit3xymh73m" />
                <span className="font-medium text-white" data-id="element-1608" data-mp="28f3lbgxgsdyb">Homepage</span>
              </div>
              <ArrowRightIcon className="w-4 h-4 text-navy-300 group-hover:text-white group-hover:translate-x-1 transition-all" data-id="element-1609" data-mp="2da996lafg2p1" />
            </a>
            <a href="#/website-laten-maken" className="flex items-center justify-between bg-white/5 hover:bg-white/10 border border-white/10 p-5 rounded-xl transition-all group" data-id="element-1610" data-mp="24bxjqmlaray6">
              <div className="flex items-center gap-3" data-id="element-1611" data-mp="1umnpb02zdg6w">
                <SearchIcon className="w-5 h-5 text-accent" data-id="element-1612" data-mp="1gltfqe47596n" />
                <span className="font-medium text-white" data-id="element-1613" data-mp="1gmcyfx1o81lq">Diensten</span>
              </div>
              <ArrowRightIcon className="w-4 h-4 text-navy-300 group-hover:text-white group-hover:translate-x-1 transition-all" data-id="element-1614" data-mp="1km51xvc7jhk8" />
            </a>
            <a href="#/kennisbank" className="flex items-center justify-between bg-white/5 hover:bg-white/10 border border-white/10 p-5 rounded-xl transition-all group" data-id="element-1615" data-mp="18l59u3kjdp6u">
              <div className="flex items-center gap-3" data-id="element-1616" data-mp="yvlp0sd9jl9c">
                <BookOpenIcon className="w-5 h-5 text-accent" data-id="element-1617" data-mp="yv29tjezzaz0" />
                <span className="font-medium text-white" data-id="element-1618" data-mp="uus3u6r7gkk5">Kennisbank</span>
              </div>
              <ArrowRightIcon className="w-4 h-4 text-navy-300 group-hover:text-white group-hover:translate-x-1 transition-all" data-id="element-1619" data-mp="pue4re7l0ky9" />
            </a>
            <a href="#/alle-locaties" className="flex items-center justify-between bg-white/5 hover:bg-white/10 border border-white/10 p-5 rounded-xl transition-all group" data-id="element-1620" data-mp="kxnexz5z6azn">
              <div className="flex items-center gap-3" data-id="element-1621" data-mp="2f77v1xt604qm">
                <MapPinIcon className="w-5 h-5 text-accent" data-id="element-1622" data-mp="2absiraat2gwb" />
                <span className="font-medium text-white" data-id="element-1623" data-mp="2irrgj4j0b3hs">Alle locaties</span>
              </div>
              <ArrowRightIcon className="w-4 h-4 text-navy-300 group-hover:text-white group-hover:translate-x-1 transition-all" data-id="element-1624" data-mp="2msv0a246djoa" />
            </a>
          </div>
        </div>
      </section>
    </main>;
}